const SportsBackground = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden opacity-[0.03] dark:opacity-[0.02]">
      <svg 
        className="absolute inset-0 w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern id="sports-pattern" x="0" y="0" width="200" height="200" patternUnits="userSpaceOnUse">
            {/* Football */}
            <circle cx="30" cy="30" r="15" fill="none" stroke="currentColor" strokeWidth="1.5" />
            <path d="M30 15 L30 45 M15 30 L45 30" stroke="currentColor" strokeWidth="1" />
            <path d="M20 20 L40 40 M40 20 L20 40" stroke="currentColor" strokeWidth="0.5" />
            
            {/* Trophy */}
            <path d="M100 60 L100 80 M90 80 L110 80" stroke="currentColor" strokeWidth="1.5" fill="none" />
            <path d="M85 40 Q85 60 100 60 Q115 60 115 40 L85 40" stroke="currentColor" strokeWidth="1.5" fill="none" />
            <path d="M85 45 Q75 45 75 55 Q75 60 85 55" stroke="currentColor" strokeWidth="1" fill="none" />
            <path d="M115 45 Q125 45 125 55 Q125 60 115 55" stroke="currentColor" strokeWidth="1" fill="none" />
            
            {/* Goal net pattern */}
            <rect x="150" y="20" width="40" height="30" fill="none" stroke="currentColor" strokeWidth="1" />
            <line x1="150" y1="30" x2="190" y2="30" stroke="currentColor" strokeWidth="0.5" />
            <line x1="150" y1="40" x2="190" y2="40" stroke="currentColor" strokeWidth="0.5" />
            <line x1="160" y1="20" x2="160" y2="50" stroke="currentColor" strokeWidth="0.5" />
            <line x1="170" y1="20" x2="170" y2="50" stroke="currentColor" strokeWidth="0.5" />
            <line x1="180" y1="20" x2="180" y2="50" stroke="currentColor" strokeWidth="0.5" />
            
            {/* Stars */}
            <path d="M50 120 L52 126 L58 126 L53 130 L55 136 L50 132 L45 136 L47 130 L42 126 L48 126 Z" fill="currentColor" />
            <path d="M150 130 L151.5 134 L156 134 L152.5 137 L154 141 L150 138 L146 141 L147.5 137 L144 134 L148.5 134 Z" fill="currentColor" />
            
            {/* Field lines */}
            <circle cx="100" cy="150" r="20" fill="none" stroke="currentColor" strokeWidth="1" />
            <circle cx="100" cy="150" r="3" fill="currentColor" />
            <line x1="60" y1="130" x2="60" y2="170" stroke="currentColor" strokeWidth="1" />
            <line x1="140" y1="130" x2="140" y2="170" stroke="currentColor" strokeWidth="1" />
            
            {/* Whistle */}
            <ellipse cx="30" cy="170" rx="12" ry="8" fill="none" stroke="currentColor" strokeWidth="1.5" />
            <line x1="42" y1="170" x2="50" y2="165" stroke="currentColor" strokeWidth="1.5" />
            <circle cx="50" cy="165" r="3" fill="none" stroke="currentColor" strokeWidth="1" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#sports-pattern)" className="text-foreground" />
      </svg>
    </div>
  );
};

export default SportsBackground;
